import { ArticleLayout } from '@/components/ArticleLayout'
import WalkMiningWebApi from '@/util/client/WalkMiningWebApiConnector'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

export default function detailPage(props: any) {
  const { data } = props

  return <ArticleLayout meta={data} {...props} />
}

export async function getServerSideProps(ctx: any) {
  const isSSR = ctx.req !== null && ctx.req !== undefined
  const { id } = ctx.query

  const response = await WalkMiningWebApi.getNotice(id, ctx.locale, isSSR)
  var data = null
  if (response) {
    data = response
  }

  return {
    props: {
      id: id || null,
      isSSR,
      data: data || null,
      locale: ctx.locale,
      ...(await serverSideTranslations(ctx.locale, ['translation'])),
    },
  }
}
